import { createActionWithPayload } from "store/helpers";
import { ActionTypes, IConfigPapelPadrao } from "./types";

export const set = createActionWithPayload<IConfigPapelPadrao>(ActionTypes.SET);
